import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface WiderrufsrechtState extends BasePageState {}
interface WiderrufsrechtModel {}

export default class WiderrufsrechtPage extends Basepage<
  WiderrufsrechtState,
  WiderrufsrechtModel
> {
  renderChild(): JSX.Element {
    return <div id="widerrufsrecht">Widerrufsrecht</div>;
  }
  initState(base: BasePageState): WiderrufsrechtState {
    let newState: WiderrufsrechtState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Widerrufsrecht';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Widerrufsrecht</span>;
  }
  getType(): string {
    return 'WiderrufsrechtPage';
  }
}
